export default {
  landingSectionTitle: 'Family tradition in Lastovo',
  landingSectionSubtitle:
    'Our home tells the story of who we are and what we love and cherish the most',
  bookNow: 'Book now',
  restaurant: 'Restaurant',
  yachtDocking: 'Yacht docking',
  accommodation: 'Accommodation',
  adventureTours: 'Adventure tours',
  paragraphTitle:
    'The best place to eat, sleep, dock, and have fun on Lastovo Island',
  paragraphDescription:
    "A place of an authentic simplicity and traditional Mediterranean cuisine. The island of Lastovo is distinctly different from other tourist destinations. If you're looking for a quality bite to eat and unique experiences, tavern Augusta Insula is a perfect place to visit!",
  readMore: 'Read more',
  bookRestaurant: 'Restaurant Reservations',
  bookVilla: 'Villa Booking',
  bookDock: 'Docking Reservations',
  testimonials: 'Testimonials'
}



// WEBPACK FOOTER //
// ./src/localization/en/home.js